import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";

const useAuthenticated = () => {
  const navigate = useNavigate();

  const queryClient = useQueryClient();

  const isAuthenticated = localStorage.getItem("accessToken") !== null  || sessionStorage.getItem("accessToken") !== null;

  const logout = useCallback(() => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("order-storage");
    sessionStorage.clear();
    // queryClient.setQueryData(USER_INFO, null);

    navigate("/");
  }, [queryClient, navigate]);

  return { isAuthenticated, logout };
};

export default useAuthenticated;
